export const employeeAccounting = {
  "employeeAccounting.education.catalog.create":
    "employeeAccounting.education.catalog.create",
  "employeeAccounting.curriculum.group.create":
    "employeeAccounting.curriculum.group.create",
  "employeeAccounting.curriculum.group.update":
    "employeeAccounting.curriculum.group.update",
  "employeeAccounting.curriculum.group.delete":
    "employeeAccounting.curriculum.group.delete",
  "employeeAccounting.curriculum.level.create":
    "employeeAccounting.curriculum.level.create",
  "employeeAccounting.curriculum.level.update":
    "employeeAccounting.curriculum.level.update",
  "employeeAccounting.curriculum.level.delete":
    "employeeAccounting.curriculum.level.delete",
  "employeeAccounting.curriculum.course.create": "editor.staff.create",
  "employeeAccounting.curriculum.course.update": "editor.staff.edit",
  "employeeAccounting.curriculum.course.delete":
    "employeeAccounting.curriculum.course.delete",
  "employeeAccounting.curriculum.program.create":
    "employeeAccounting.curriculum.program.create",
  "employeeAccounting.curriculum.program.update":
    "employeeAccounting.curriculum.program.update",
  "employeeAccounting.table.get": "employeeAccounting.table.get",
  "employeeAccounting.position.create": "employeeAccounting.position.create",
  "employeeAccounting.position.update": "employeeAccounting.position.update",
  "employeeAccounting.position.delete": "employeeAccounting.position.delete",
  "employeeAccounting.position.direction.create":
    "employeeAccounting.position.direction.create",
  "employeeAccounting.position.direction.update":
    "employeeAccounting.position.direction.update",
  "employeeAccounting.information.system.create":
    "employeeAccounting.information.system.create",
  "employeeAccounting.information.system.update":
    "employeeAccounting.information.system.update",
  "employeeAccounting.personal.info.create":
    "employeeAccounting.personal.info.create",
  "employeeAccounting.personal.info.update":
    "employeeAccounting.personal.info.update",
  "employeeAccounting.employee.create": "employeeAccounting.employee.create",
  "employeeAccounting.employee.update": "employeeAccounting.employee.update",
  "employeeAccounting.employee.card.edit.all":
    "employeeAccounting.employee.card.edit.all",
  "employeeAccounting.employee.card.edit.partial":
    "employeeAccounting.employee.card.edit.partial",
  "employeeAccounting.employee.position.create":
    "employeeAccounting.employee.position.create",
  "employeeAccounting.employee.position.update":
    "employeeAccounting.employee.position.update",
  "employeeAccounting.employee.position.restore":
    "employeeAccounting.employee.position.restore",
  "employeeAccounting.employee.position.status.update":
    "employeeAccounting.employee.position.status.update",
  "employeeAccounting.employee.status.change":
    "employeeAccounting.employee.status.change",
  "employeeAccounting.employee.email.create":
    "employeeAccounting.employee.email.create",
  "employeeAccounting.employee.email.check":
    "employeeAccounting.employee.email.check",
  "employeeAccounting.employee.expectation.group.update":
    "employeeAccounting.employee.expectation.group.update",
  "employeeAccounting.education.catalog.get":
    "employeeAccounting.education.catalog.get",
  "employeeAccounting.education.catalog.delete":
    "employeeAccounting.education.catalog.delete",
  "employeeAccounting.curriculum.group.get":
    "employeeAccounting.curriculum.group.get",
  "employeeAccounting.curriculum.level.get":
    "employeeAccounting.curriculum.level.get",
  "employeeAccounting.curriculum.course.get": "editor.staff.get",
  "employeeAccounting.curriculum.program.get":
    "employeeAccounting.curriculum.program.get",
  "employeeAccounting.position.get": "employeeAccounting.position.get",
  "employeeAccounting.combinationRule.get":
    "employeeAccounting.combinationRule.get",
  "employeeAccounting.combinationRule.create":
    "employeeAccounting.combinationRule.create",
  "employeeAccounting.combinationRule.update":
    "employeeAccounting.combinationRule.update",
  "employeeAccounting.combinationRule.delete":
    "employeeAccounting.combinationRule.delete",
  "employeeAccounting.position.direction.get":
    "employeeAccounting.position.direction.get",
  "employeeAccounting.information.system.get":
    "employeeAccounting.information.system.get",
  "employeeAccounting.personal.info.get":
    "employeeAccounting.personal.info.get",
  "employeeAccounting.employee.get": "employeeAccounting.employee.get",
  "employeeAccounting.employee.position.get":
    "employeeAccounting.employee.position.get",
  "employeeAccounting.employee.email.get":
    "employeeAccounting.employee.email.get",
  "employeeAccounting.employee.expectation.group.get":
    "employeeAccounting.employee.expectation.group.get",
  "employeeAccounting.stats.passage.get":
    "employeeAccounting.stats.passage.get",
  "employeeAccounting.report.get": "employeeAccounting.report.get",
  "employeeAccounting.employee.list.get": "employeeAccounting.employee.get",
  "employeeAccounting.employee.position.verify":
    "employeeAccounting.employee.position.verify",
  "employeeAccounting.employee.position.reject":
    "employeeAccounting.employee.position.reject",
  "employeeAccounting.employee.position.send.check":
    "employeeAccounting.employee.position.send.check",
  "employeeAccounting.employee.position.status.extend":
    "employeeAccounting.employee.position.status.extend",
  "employeeAccounting.employee.email.domain.check":
    "employeeAccounting.employee.email.domain.check",
  "employeeAccounting.employee.report.get":
    "employeeAccounting.employee.report.get",
  "employeeAccounting.position.direction.statuses.get":
    "employeeAccounting.position.direction.statuses.get",
  "employeeAccounting.consents.template.get":
    "employeeAccounting.consents.template.get",
  "employeeAccounting.curriculum.program.positions.get":
    "employeeAccounting.curriculum.program.positions.get",
  "employeeAccounting.curriculum.program.positions.without.get":
    "employeeAccounting.curriculum.program.positions.without.get",
  "employeeAccounting.education.dealer.table.get":
    "employeeAccounting.education.dealer.table.get",
  "employeeAccounting.expectations": "employeeAccounting.expectations",
  "employeeAccounting.deleteExpectations":
    "employeeAccounting.deleteExpectations",
  "employeeAccounting.updateExpectations":
    "employeeAccounting.updateExpectations",
  "employeeAccounting.createExpectations":
    "employeeAccounting.createExpectations",
  "employeeAccounting.statistics.bonus.report.get":
    "employeeAccounting.statistics.bonus.report.get",
  "employeeAccounting.statistics.report.get":
    "employeeAccounting.statistics.report.get",
  "employeeAccounting.statistics.get": "employeeAccounting.statistics.get",
  "employeeAccounting.statistics.bonus.report.save":
    "employeeAccounting.statistics.bonus.report.save",
  "employeeAccounting.statistics.quarter":
    "employeeAccounting.statistics.quarter",
  "employeeAccounting.statistics.quarter.appeal.createAppealFile":
    "employeeAccounting.statistics.quarter.appeal.createAppealFile",
  "employeeAccounting.statistics.quarter.appeal.deleteAppealFile":
    "employeeAccounting.statistics.quarter.appeal.deleteAppealFile",
  "employeeAccounting.statistics.quarter.appeal.editAppealFile":
    "employeeAccounting.statistics.quarter.appeal.editAppealFile",
  "employeeAccounting.statistics.quarter.appeal.getAppealFile":
    "employeeAccounting.statistics.quarter.appeal.getAppealFile",
  "passport.get": "passport.get",
  "employeeAccounting.appeal.send": "employeeAccounting.appeal.send",
  "employeeAccounting.appeal.report": "employeeAccounting.appeal.report",
  "employeeAccounting.appeal.periods.upsert":
    "employeeAccounting.appeal.periods.upsert",
  "employeeAccounting.appeal.periods.get":
    "employeeAccounting.appeal.periods.get",
  "employeeAccounting.appeal.review": "employeeAccounting.appeal.review",
  "employeeAccounting.appeal.close": "employeeAccounting.appeal.close",
  "employeeAccounting.appeal.getList": "employeeAccounting.appeal.getList",
  "employeeAccounting.employee.compare": "employeeAccounting.employee.compare",
  "employeeAccounting.tariffs.get": "employeeAccounting.tariffs.get",
  "employeeAccounting.tariffs.export.get":
    "employeeAccounting.tariffs.export.get",
  "employeeAccounting.tariffs.id.get": "employeeAccounting.tariffs.id.get",
  "employeeAccounting.tariffs.id.put": "employeeAccounting.tariffs.id.put",
  "employeeAccounting.licenses.get": "employeeAccounting.licenses.get",
  "employeeAccounting.licenses.assign.post":
    "employeeAccounting.licenses.assign.post",
  "employeeAccounting.licenses.revoke.post":
    "employeeAccounting.licenses.revoke.post",
  "employeeAccounting.licenses.id.change-tariff.put":
    "employeeAccounting.licenses.id.change-tariff.put",
  "employeeAccounting.licenses.employee.employeeId.get":
    "employeeAccounting.licenses.employee.employeeId.get",
  "employeeAccounting.licenses.mass-assign.post":
    "employeeAccounting.licenses.mass-assign.post",
  "employeeAccounting.licenses.mass-revoke.post":
    "employeeAccounting.licenses.mass-revoke.post",
  "employeeAccounting.license-requests.calculate.put":
    "employeeAccounting.license-requests.calculate.put",
  "employeeAccounting.license-requests.get":
    "employeeAccounting.license-requests.get",
  "employeeAccounting.license-requests.post":
    "employeeAccounting.license-requests.post",
  "employeeAccounting.license-requests.id.get":
    "employeeAccounting.license-requests.id.get",
  "employeeAccounting.license-requests.id.put":
    "employeeAccounting.license-requests.id.put",
  "employeeAccounting.license-requests.export.get":
    "employeeAccounting.license-requests.export.get",
  "employeeAccounting.license-requests.id.export.get":
    "employeeAccounting.license-requests.id.export.get",
  "employeeAccounting.partners.get": "employeeAccounting.partners.get",
  "employeeAccounting.partners.put": "employeeAccounting.partners.put",
  "employeeAccounting.partners.delete": "employeeAccounting.partners.delete",
  "employeeAccounting.bonus.columns.update":
    "employeeAccounting.bonus.columns.update",
} as const;
